












































import type { PropType } from '@vue/composition-api';
import { defineComponent, toRefs } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import {
  SidebarInnerWrapper,
  SidebarPlacement,
  ChatContent,
  ChatActions,
  ChatHeader,
  NewChatHeader,
} from '@getaccept/dsr-shared';
import type { ChatParticipant, Message } from '@getaccept/dsr-shared';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import { useChatPublishedStore } from '../store/chat-published.store';
import { useParticipantsStore } from '../../store/participants.store';

export default defineComponent({
  name: 'ChatWrapper',
  components: {
    ChatContent,
    ChatActions,
    SidebarInnerWrapper,
    ChatHeader,
    NewChatHeader,
  },
  props: {
    recipientId: {
      required: true,
      type: String,
    },
    newChat: {
      type: Boolean,
    },
    placement: {
      type: String as PropType<SidebarPlacement>,
      default: () => SidebarPlacement.Right,
    },
    loaded: {
      type: Boolean,
    },
    creatingNewConversation: {
      type: Boolean,
    },
    participants: {
      type: Array as PropType<ChatParticipant[]>,
      default: () => [],
    },
    roomOwner: {
      type: Object as PropType<User>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const participantsStore = useParticipantsStore();
    const {
      chat,
      createMessage,
      setMessageReadBy,
      setTypingStatus,
      deleteMessage,
      setReplyMessage,
      useConversationLastReadList,
      handleNewConversationParticipants,
      createConversation,
    } = useChatPublishedStore();
    const { recipients, user } = storeToRefs(participantsStore);

    const owner: ChatParticipant = {
      recipientId: props.recipientId,
    };

    const lastReads = useConversationLastReadList(recipients.value, user.value, {
      recipientId: props.recipientId,
    });

    const handleSend = async (text: string) => {
      if (props.creatingNewConversation) {
        await createConversation(props.recipientId, text);
        emit('conversation-created');
        return;
      }
      createMessage(text, props.recipientId);
      handleClearReply();
    };

    const handleRead = (messageId: string) => setMessageReadBy(messageId);
    const handleTyping = (isTyping: boolean) => setTypingStatus(isTyping);
    const handleDelete = (messageId: string) => deleteMessage(messageId);

    const handleReply = (message: Message) => {
      setReplyMessage(message);
    };

    const handleClearReply = (): void => {
      setReplyMessage(undefined);
    };

    return {
      ...toRefs(chat),
      recipients,
      user,
      handleSend,
      owner,
      handleRead,
      lastReads,
      handleTyping,
      handleDelete,
      handleReply,
      handleClearReply,
      handleNewConversationParticipants,
    };
  },
});
